export default "__VITE_ASSET__Cm6rVFQ9__"